import * as Licenses from '../services/Licenses'

export const RECEIVE_LICENSES = 'RECEIVE_LICENSES'
export const RECEIVE_LICENSE = 'RECEIVE_LICENSE'
export const RECEIVE_LICENSE_GROUP_OPTIONS = 'RECEIVE_LICENSE_GROUP_OPTIONS'

function receiveLicenses(state, query, licenses) {
  return {
    type: RECEIVE_LICENSES,
    query,
    licenses,
  }
}

export const fetchLicenses = (query) => (dispatch, getState) => {
  const state = getState()
  let subsidiaryId = state.currentUser.subsidiary
  Licenses.searchLicenses(query, subsidiaryId).then((data) => dispatch(receiveLicenses(state, query, data)))
}

export const fetchLicensesByActivationCode = (query) => (dispatch, getState) => {
  const state = getState()
  let subsidiaryId = state.currentUser.subsidiary
  return Licenses.searchLicensesByActivationCode(query, subsidiaryId).then((data) => dispatch(receiveLicenses(state, query, data)))
}

export const fetchLicensesByActivationCodeOrUserId = (query, page) => (dispatch, getState) => {
  const state = getState()
  let subsidiaryId = state.currentUser.subsidiary
  return Licenses.searchLicensesByActivationCodeOrUserId(query, page).then((data) => dispatch(receiveLicenses(state, query, data)))
}

function receiveLicense(state, license) {
  return {
    type: RECEIVE_LICENSE,
    license: license ? license : { id: -1 },
  }
}

export const fetchLicense = (param) => (dispatch, getState) => {
  const state = getState()
  const subsidiaryId = state.currentUser.subsidiary
  Licenses.getLicense(param, subsidiaryId).then((data) => dispatch(receiveLicense(state, data)))
}

function receiveLicenseGroupOptions(state, groupOptions) {
  return {
    type: RECEIVE_LICENSE_GROUP_OPTIONS,
    groupOptions: groupOptions,
  }
}

export const fetchLicenseGroupOptions = (param) => (dispatch, getState) => {
  const state = getState()
  const subsidiaryId = state.currentUser.subsidiary
  Licenses.getLicenseGroupOptions(param, subsidiaryId).then((data) => dispatch(receiveLicenseGroupOptions(state, data)))
}

export const sendActivationCode = (id, email) => (dispatch, getState) => {
  const state = getState()
  const subsidiaryId = state.currentUser.subsidiary
  Licenses.sendActivationCode(id, subsidiaryId, email)
}

export const rollbackLicense = (id) => (dispatch, getState) => {
  const state = getState()
  const subsidiaryId = state.currentUser.subsidiary
  return Licenses.rollback(id, subsidiaryId)
}

export const updateLicense = (license) => (dispatch, getState) => {
  const state = getState()
  const subsidiaryId = state.currentUser.subsidiary
  return Licenses.update(license, subsidiaryId)
}

export const RESET_SEARCH_RESULTS = 'RESET_SEARCH_RESULTS';

export const resetSearchResults = () => ({
  type: RESET_SEARCH_RESULTS,
});
